import React from 'react';
import FeatureCard from './FeatureCard';
import { Clock, Users, Monitor } from 'lucide-react';

const AboutSection = () => {
  const features = [
    {
      icon: Clock,
      title: 'Desde 1995',
      description: 'Quase 30 anos de experiência em medicina e segurança do trabalho, tornando-nos referência no mercado.'
    },
    {
      icon: Users,
      title: 'Médicos Especialistas',
      description: 'Corpo clínico composto por Médicos do Trabalho registrados e reconhecidos na área.'
    },
    {
      icon: Monitor,
      title: 'Tecnologia Moderna',
      description: 'Estrutura moderna com equipamentos de última geração e sistema online para maior praticidade.'
    }
  ];

  return (
    <section className="about-section">
      <div className="container">
        <div className="features-grid">
          {features.map((feature, index) => (
            <FeatureCard key={index} {...feature} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;